import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReferenceDataLabels } from 'rome-library';
import { WritingBusinessInfoDto } from '../../models/writing-business-info-dto.model';
import { BrokerUserService } from '../../services/broker-user.service';

@UntilDestroy()
@Component({
  selector: 'boi-writing-business',
  templateUrl: './writing-business.page.html'
})
export class WritingBusinessPage implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;
  public writingBusinessData: WritingBusinessInfoDto;

  constructor(private readonly activatedRoute: ActivatedRoute, private readonly brokerUserService: BrokerUserService) {}

  ngOnInit(): void {
    const agentId = this.activatedRoute.snapshot.params['agentId'];

    this.brokerUserService
      .getAgentWritingBusinessData(agentId)
      .pipe(untilDestroyed(this))
      .subscribe((writingBusinessData) => {
        this.writingBusinessData = writingBusinessData;
      });
  }
}
